import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import { setFileData } from '../../api/features/fileSlice'
import TextInputRegular from '../inputs/TextInputRegular'

const ReturnReceiptFormFields = ({ expectsReturnReceipt, returnReceiptReminderDays, onChange }) => {
  const { t } = useTranslation()
  const fileData = useSelector((state) => state.file.fileData)
  const dispatch = useDispatch()

  const isControlled = typeof onChange === 'function'
  const checked = isControlled ? expectsReturnReceipt : fileData?.expectsReturnReceipt
  const reminderDays = isControlled ? returnReceiptReminderDays : fileData?.returnReceiptReminderDays

  const updateFields = (updates) => {
    if (isControlled) {
      onChange(updates)
      return
    }

    dispatch(
      setFileData({
        ...fileData,
        ...updates,
      }),
    )
  }

  const handleCheckboxChange = () => {
    updateFields({
      expectsReturnReceipt: !checked,
      returnReceiptReminderDays: reminderDays || 14,
    })
  }

  const handleDaysChange = (value) => {
    const days = parseInt(value, 10)
    updateFields({
      returnReceiptReminderDays: Number.isNaN(days) || days < 1 ? 14 : days,
    })
  }

  return (
    <div className="flex flex-col gap-2 border-t border-neutral mt-2 bg-gray-100 rounded-lg px-4 py-3">
      <label className="flex items-center gap-2 cursor-pointer">
        <input type="checkbox" checked={!!checked} onChange={handleCheckboxChange} />
        <span className="text-sm">{t('return_receipt_expected')}</span>
      </label>
      {checked ? (
        <div className="flex flex-col items-center gap-2">
          <label className="text-sm whitespace-nowrap text-start w-full">{t('return_receipt_reminder_days')}</label>
          <TextInputRegular
            type="number"
            min={1}
            value={reminderDays ?? 14}
            onChange={(e) => handleDaysChange(e.target.value)}
          />
        </div>
      ) : null}
    </div>
  )
}

export default ReturnReceiptFormFields
